import { version } from 'os';
import { serialize } from 'v8';

import { others } from '@chakra-ui/system';

export const servers = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    serial: { en: 'Serial', ko: '시리얼', fr: '' },
    version: { en: 'Version', ko: '버전', fr: '' },
    etc: { en: 'Etc', ko: '기타', fr: '' },
    regDate: { en: 'Reg Date', ko: '등록일자', fr: '' },
    distrributor: { en: 'Distibutor', ko: '대리점', fr: '' },
    shippingDate: { en: 'Shipping Date', ko: '출하일자', fr: '' },
    active: { en: 'Active', ko: '활성여부', fr: '' },
    download: { en: 'Download', ko: '다운로드', fr: '' },
  },
  info: {
    no: { en: 'No.', ko: '번호', fr: '' },
    serial: { en: 'Serial', ko: '시리얼', fr: '' },
    version: { en: 'Version', ko: '버전', fr: '' },
    etc: { en: 'Etc', ko: '기타', fr: '' },
    regDate: { en: 'Reg Date', ko: '등록일자', fr: '' },
    distrributor: { en: 'Distibutor', ko: '대리점', fr: '' },
    download: { en: 'Download', ko: '다운로드', fr: '' },
    shippingDate: { en: 'Shipping Date', ko: '출하일자', fr: '' },
    licenseHistory: { en: 'License History', ko: '라이선스 이력', fr: '' },
  },
  placeholder: {
    serial: { en: 'Search by serial', ko: '시리얼을 입력하세요.' },
  },
};
